module.exports = __webpack_public_path__ + "img/about-icon-6.14c47115.png";